import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ICategory,
  ICountry,
  IPaginatedResponse,
  IProduct,
} from '@boma/administration-portal/shared/entities';
import { APP_CONFIG } from '@boma/app-config';
@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listProducts(page: string = '1', perPage: string = '25', query: string = '') {
    let params = {
      page,
      perPage,
      query,
    };

    if (page == null) {
      params['page'] = '1';
    }

    return this.httpClient.get<IPaginatedResponse<IProduct>>(
      `${this.base}api/v${this.version}/Products`,
      {
        params,
      }
    );
  }

  listLocalProducts(
    page: string = '1',
    perPage: string = '25',
    query: string = ''
  ) {
    let params = {
      page,
      perPage,
      query,
    };

    if (page == null) {
      params['page'] = '1';
    }

    return this.httpClient.get<IPaginatedResponse<IProduct>>(
      `${this.base}api/v${this.version}/Products/GetLocalProducts`,
      {
        params,
      }
    );
  }

  uploadProductImage(file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<string>(
      `${this.base}api/v${this.version}/Products/UploadImage`,
      formData
    );
  }

  loadProductDetails(id: string) {
    return this.httpClient.get<IProduct>(
      `${this.base}api/v${this.version}/Products/${id}`
    );
  }

  setProductToGlobal(id: string) {
    return this.httpClient.put<IProduct>(
      `${this.base}api/v${this.version}/Products/SetProductToGlobal/${id}`,
      {}
    );
  }

  deleteProduct(id: string) {
    return this.httpClient.delete<any>(
      `${this.base}api/v${this.version}/Products/${id}`
    );
  }

  createProduct(product: any) {
    return this.httpClient.post<IProduct>(
      `${this.base}api/v${this.version}/Products`,
      {
        ...product,
      }
    );
  }

  addProductCountryTaxDefinition(productId: string, taxDefintionId: string) {
    return this.httpClient.post<IProduct>(
      `${this.base}api/v${this.version}/Products/${productId}/TaxDefinitions`,
      {
        taxDefinitionId: taxDefintionId,
      }
    );
  }

  removeProductTaxDefinition(productId: string, taxDefinitionId: string) {
    return this.httpClient.delete<any>(
      `${this.base}api/v${this.version}/Products/${productId}/TaxDefinitions/${taxDefinitionId}`
    );
  }

  updateProduct(product: any, id: string) {
    return this.httpClient.put<IProduct>(
      `${this.base}api/v${this.version}/Products/${id}`,
      {
        ...product,
      }
    );
  }

  getCountries() {
    return this.httpClient.get<ICountry[]>(
      `${this.base}api/v${this.version}/Countries`
    );
  }

  getTaxDefinitions(countryId: string) {
    return this.httpClient.get<ICountry>(
      `${this.base}api/v${this.version}/Countries/${countryId}`
    );
  }

  searchCategories(searchTerm: string = null) {
    const queryString = searchTerm == null ? '' : `?query=${searchTerm}`;

    return this.httpClient.get<ICategory[]>(
      `${this.base}api/v${this.version}/Categories/Search${queryString}`
    );
  }
}
